<template>
  <b-container v-if="type && models" fluid>
    <page-title icon="fas fa-shipping-fast">
      <translate>Tours</translate>
    </page-title>

    <api-list type="tours" :model="models.tours" :quick-filters="quickFiltersSetup.tours" />

  </b-container>
</template>

<script>
import ApiList from '@/components/ApiLists/ApiList'

export default {
  name: 'ToursList',
  title() {
    return this.$gettext('Tours')
  },
  components: {
    ApiList
  },
  props: {
    type: {
      type: String,
      default: 'tours'
    }
  }
}
</script>
